import Env from '../../util/env';
import {contactDBRoutes, serviceURL} from '../../util/uiconstants';
import {UPDATE_CONTACTS_ACCESS} from '../actiontypes';

const getURL = (projectId, entityId) =>
	`${Env.getBaseURL(serviceURL)}${contactDBRoutes.projects}/${projectId}/${contactDBRoutes.entities}/${entityId}`;

export const updateContactsAccess = (projectId, entityId, payload) => {
	const url = getURL(projectId, entityId);
	return {
		type: UPDATE_CONTACTS_ACCESS,
		meta: {
			api: {
				url,
				method: 'PATCH',
				data: payload
			}
		}
	};
};
